<template>
  <div class="flex_center">
    <agree-text-index :has-video="hasVideo" :country="country" />
  </div>
</template>

<script>
import AgreeTextIndex from '@/routes_new/outer/interview/landing/components/agree-text/index';

export default {
  name: 'AgreementDefault',

  components: { AgreeTextIndex },

  props: {
    country: {
      type: String,
      default: ''
    },

    hasVideo: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.agreement {
  color: #9faab6;
  margin-top: 20px;

  ::v-deep a {
    color: #9faab6;
    text-decoration: underline;

    &:hover {
      color: $green-hover;
    }
  }
}

.flex_center {
  display: flex;
  align-items: flex-start;
}

.margin_right {
  margin-right: 10px;
}
</style>
